import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import { Dropdown as BaseDropdown } from './dropdown';
import { DropdownMenu as BaseDropdownMenu } from './menu';
export * from './item';
// Don't export the generic type class, because it will break down the type inference 
// declare class _Dropdown extends BaseDropdown<
// DropdownProps,
// DropdownEvents,
// DropdownBlocks
// > { } 
// declare class _DropdownMenu extends BaseDropdownMenu<
// DropdownMenuProps,
// DropdownMenuEvents,
// DropdownMenuBlocks
// > { }
// export const Dropdown = BaseDropdown as typeof _Dropdown;
// export const DropdownMenu = BaseDropdownMenu as typeof _DropdownMenu;
// above codes can not be used as instance type
export var Dropdown = /*#__PURE__*/function (_BaseDropdown) {
  _inheritsLoose(Dropdown, _BaseDropdown);
  function Dropdown() {
    return _BaseDropdown.apply(this, arguments) || this;
  }
  return Dropdown;
}(BaseDropdown);
export var DropdownMenu = /*#__PURE__*/function (_BaseDropdownMenu) {
  _inheritsLoose(DropdownMenu, _BaseDropdownMenu);
  function DropdownMenu() {
    return _BaseDropdownMenu.apply(this, arguments) || this;
  }
  return DropdownMenu;
}(BaseDropdownMenu);